import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OnboardingBanner.module.css';

export default function OnboardingBanner({ hasChannels, hasBots }) {
  const { t } = useTranslation('dashboard');
  const completedCount = (hasChannels ? 1 : 0) + (hasBots ? 1 : 0);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <span className={styles.emoji}>🚀</span>
        <div>
          <div className={styles.title}>{t('onboarding.title')}</div>
          <div className={styles.description}>{t('onboarding.description')}</div>
        </div>
      </div>
      <div className={styles.progress}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${(completedCount / 2) * 100}%` }}
          />
        </div>
        <span className={styles.progressText}>{completedCount}/2</span>
      </div>
    </div>
  );
}
